import AuthEndpoint from "@/core/services/api/endpoints/common/AuthEndpoint";
import ProfileEndpoint from "@/core/services/api/endpoints/common/ProfileEndpoint";
import TwoFactorAuth from "@/core/services/api/endpoints/common/TwoFactorAuth";
import DictionaryEndpoint from "@/core/services/api/endpoints/common/DictionaryEndpoint";
import ProductEndpoint from "@/core/services/api/endpoints/common/ProductEndpoint";
import ExchangeEndpoint from "@/core/services/api/endpoints/common/ExchangeEndpoint";
import DocumentationEndpoint from "@/core/services/api/endpoints/common/DocumentationEndpoint";
import WhiteLabelFrontEndEndpoint from "@/core/services/api/endpoints/common/WhiteLabelFrontEndEndpoint";

class CommonEndpoints {
  public auth = new AuthEndpoint();
  public profile = new ProfileEndpoint();
  public dictionary = new DictionaryEndpoint();
  public two_factor_auth = new TwoFactorAuth();
  public product = new ProductEndpoint();
  public exchange = new ExchangeEndpoint();
  public documentation = new DocumentationEndpoint();
  public white_label = new WhiteLabelFrontEndEndpoint();
}

export default CommonEndpoints;
